//
// locales/glitch/eo.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/eo';
import localeData from 'react-intl/locale-data/eo.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
